/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme, ThemeOptions } from "@mui/material";

export const typographyStyle = (theme: Theme): ThemeOptions["typography"] => {
  const headlineCommonStyles = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
  };

  return {
    fontFamily: "'Inter', sans-serif",
    h1: {
      ...headlineCommonStyles,
      fontSize: "3.375rem",
      lineHeight: 1.08,
      marginTop: "1.25rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: "4.5rem",
      },
    },
    h2: {
      ...headlineCommonStyles,
      lineHeight: 1.16,
      fontSize: "3rem",
      marginTop: "1.25rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: "3.5rem",
      },
    },
    h3: {
      ...headlineCommonStyles,
      fontSize: "2.5rem",
      lineHeight: 1.16,
      marginTop: "1.25rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: "3rem",
      },
    },
    h4: {
      ...headlineCommonStyles,
      fontSize: "2rem",
      lineHeight: 1.24,
      marginTop: "0.625rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: "2.5rem",
      },
    },
    h5: {
      ...headlineCommonStyles,
      fontSize: "1.5rem",
      lineHeight: 1.32,
      marginTop: "0.625rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: "2rem",
        lineHeight: 1.24,
      },
    },
    h6: {
      ...headlineCommonStyles,
      fontSize: "1.125rem",
      lineHeight: 1.32,
      [theme.breakpoints.up("sm")]: {
        fontSize: "1.5rem",
      },
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.56,
      fontWeight: 400,
      [theme.breakpoints.up("sm")]: {
        fontSize: "1.125rem",
      },
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.56,
      fontWeight: 400,
      [theme.breakpoints.up("sm")]: {
        fontSize: "1rem",
      },
    },
    body3: {
      fontSize: "0.75rem",
      lineHeight: 1.56,
      fontWeight: 400,
      [theme.breakpoints.up("sm")]: {
        fontSize: "0.875rem",
      },
    },
    button: {
      fontSize: "1.125rem",
      lineHeight: 1.2,
      fontWeight: 500,
      textTransform: "none",
    },
    cardTitle: {
      fontFamily: "'Roboto', sans-serif",
      fontSize: "1.125rem",
      lineHeight: 1.56,
      fontWeight: 600,
      [theme.breakpoints.up("sm")]: {
        fontSize: "1.25rem",
      },
    },
  };
};
